"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var modules_1 = require("@dynamynd/modules");

var styled_components_1 = __importDefault(require("styled-components"));

exports.NaturalAdvantageTitleDecorated = styled_components_1.default(modules_1.NaturalAdvantageTitle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 25px;\n"], ["\n    margin-top: 25px;\n"])));
var templateObject_1;